import { RefreshCw } from 'lucide-react'

interface UpdateBannerProps {
  onRefresh: () => void
}

export function UpdateBanner({ onRefresh }: UpdateBannerProps) {
  return (
    <div className="fixed top-0 left-0 right-0 z-[200] bg-[#f7931a] text-white flex items-center justify-center gap-3 px-4 py-2 text-sm font-medium shadow-lg">
      <RefreshCw className="h-4 w-4" />
      <span>A new version is available.</span>
      <button
        onClick={onRefresh}
        className="inline-flex items-center gap-1 rounded-md px-3 py-1 bg-white/20 hover:bg-white/30 text-white font-semibold text-sm transition-colors"
      >
        Refresh now
      </button>
    </div>
  )
}
